export default __webpack_public_path__ + "static/media/sg_flashpay_fees_backgound.b7c8bfa3.png";